import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h1", null, "Concert Feedback", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", null, "Stemmen op het Repertoire", -1)
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-12" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h2", null, "Inzendingen op het gehele Concert", -1)
const _hoisted_9 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RepertoirList = _resolveComponent("RepertoirList")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _createVNode(_component_RepertoirList, {
          songs: _ctx.songs,
          showRatings: true
        }, null, 8, ["songs"])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("ul", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.feedback, (entry, idx) => {
            return (_openBlock(), _createElementBlock("li", {
              key: idx,
              class: "cite"
            }, [
              _createTextVNode(_toDisplayString(entry.tiptop) + " ", 1),
              (entry.naam)
                ? (_openBlock(), _createElementBlock("span", _hoisted_9, "(" + _toDisplayString(entry.naam) + ")", 1))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
}